import { Flex, Spinner } from "@chakra-ui/react";
import { useApplicationContext } from "contexts/ApplicationContext";
import { useCallback, useLayoutEffect, useMemo, useState } from "react";
import PageTemplate from "pages/_page-template";
import { hasSession } from "Session";
import { Router } from "./use-router";
import { RouterChangeHandler } from "./types";

export function RouterSelect({
  redirectIfNotLogged,
  notFoundPage
}: {
  redirectIfNotLogged: string;
  notFoundPage: () => JSX.Element;
}) {
  let [currentPath, setCurrentPath] = useState<string>(Router.pathname);
  const { user } = useApplicationContext();

  const isTokenPresent = hasSession();

  const currentRoute = useMemo(() => Router.getCurrentRoute(), [currentPath]);

  const PageComponent = currentRoute?.checkPermission(user)
    ? currentRoute?.getComponent()
    : notFoundPage;

  const changeRouter: RouterChangeHandler = useCallback(() => {
    setCurrentPath(Router.pathname);
  }, []);

  Router.onRouteChange(changeRouter);

  useLayoutEffect(() => {
    const isPermited = currentRoute?.checkPermission(user);
    if (!isTokenPresent && !isPermited) {
      Router.push(redirectIfNotLogged);
    }
  }, [isTokenPresent]);

  return (
    <>
      {user.isLogging && isTokenPresent ? (
        <Flex w="100%" h="100vh" justifyContent="center" alignItems="center">
          <Spinner />
        </Flex>
      ) : (
        <PageTemplate PageComponent={PageComponent} />
      )}
    </>
  );
}
